export const DPI_MULTIPLIER = 300;
export const STANDARD_MAT_REVEAL = 0.125;
export const OVERSIZE_DIMENSIONS = {
  maxDim: 47.5,
  minDim: 35.5
};

export default {
  DPI_MULTIPLIER,
  STANDARD_MAT_REVEAL,
  OVERSIZE_DIMENSIONS
};
